// @ts-strict-ignore
import { Col } from "components/layout/Grid";
import styled from "styled-components";

export const HeadingWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: ${({ theme }) => theme.contentPadding / 4.4}px;
  position: relative;
  padding-top: 30px;
  ${({ theme: { media } }) => media.desktop`
    padding-top: 80px;
  `}
`;

export const Heading = styled.h1`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.huge}px;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  ${({ theme: { media } }) => media.tablet`
    font-size: ${({ theme }) => theme.fontSize.gigantic}px;
  `}
  ${({ theme: { media } }) => media.desktop`
    font-size: ${({ theme }) => theme.fontSize.gigantic}px;
  `}
  ${({ theme: { media } }) => media.largeDesktop`
    font-size: ${({ theme }) => theme.fontSize.extraGigantic}px;
  `}
  ${({ theme: { media } }) => media.giantDesktop`
    font-size: ${({ theme }) => theme.fontSize.extraGigantic}px;
  `}
`;

export const HeadingParagraph = styled.p`
  font-size: ${({ theme }) => theme.fontSize.small}px;
  line-height: ${({ theme }) => theme.lineHeight.medium};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  margin: 0;
  margin-bottom: ${({ theme }) => theme.mobilePadding}px;
  ${({ theme: { media } }) => media.tablet`
    font-size: ${({ theme }) => theme.fontSize.extraLarge}px;
    margin-bottom: ${({ theme }) => theme.contentPadding}px;
  `}
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.contentPadding}px;
  ${({ theme: { media } }) => media.desktop`
    flex-direction: row;
  `}
`;

export const Name = styled.a`
  color: ${({ theme }) => theme.textColors.primary};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  font-size: ${({ theme }) => theme.fontSize.large}px;
  line-height: ${({ theme }) => theme.lineHeight.medium};
  ${({ theme: { media } }) => media.tablet`
    font-size: ${({ theme }) => theme.fontSize.huge}px;
  `}
  text-decoration: none;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  padding-left: 15px;
  margin-bottom: 15px;
  height: 50px;
  ${({ theme: { media } }) => media.tablet`
    top: 65px;
  `}
  }

  ${({ theme: { media } }) => media.tablet`
    padding-left: 37px;
    margin-left: 85px;
    margin-bottom: 50px;
  `}

  border-left: solid 1px ${({ theme }) => theme.borderColors.primary};
`;

export const OptionCard = styled.div`
  min-height: 48px;
  max-width: 100%;
  left: 200px;
  right: 1136px;
  top: 198px;
  background: ${({ theme }) => theme.backgroundColors.primary};
  border: 1px solid ${({ theme }) => theme.borderColors.primary};
  box-sizing: border-box;
  box-shadow: 0px 0px 5px 1px rgba(16, 16, 26, 0.06);
  border-radius: 6px;
  padding: 0 22px;
  margin-bottom: 16px;
  cursor: pointer;
  text-align: center;
  &:hover {
    background: ${({ theme }) => theme.backgroundColors.secondary};
    border: 1px solid ${({ theme }) => theme.borderColors.primary};
  }
  p {
    margin: 11px 0;
  }
  ${({ theme }) => theme.media.tablet`
    min-height: 56px;
    max-width: 264px;
    margin-right: 24px;
    p {
      margin: 15px 0;
    }
  `}
  ${({ theme }) => theme.media.desktop`
    text-align: left;
    margin-right: 0;
  `}
`;

export const Line = styled.hr`
  border: 0px;
  border-top: 1px solid ${({ theme }) => theme.borderColors.primary};
  width: 100%;
  margin: 0;
`;

export const LegalHeadingWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 0;
  position: relative;
  padding-top: 10px;
  padding-left: 8px;
  ${({ theme: { media } }) => media.desktop`
    padding-top: 48px;
  `}
`;

export const CardsColDesktop = styled(Col)`
  display: none;
  ${({ theme: { media } }) => media.desktop`
    display: flex;
    margin-top: 24px;
    margin-bottom: 16px;
    flex-direction: column;
  `}
`;

export const LegalItem = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  position: relative;
  border-bottom: solid 1px ${({ theme }) => theme.borderColors.primary};
  cursor: pointer;
  padding: 16px 45px 16px 0;
  img {
    position: absolute;
    right: 30px;
    top: 40%;
  }
  ${({ theme }) => theme.media.desktop`
    padding-right: 50px;
  `}
`;

export const ItemsCol = styled(Col)`
  margin-bottom: 40px;
  h5 {
    margin: 0 0 16px;
  }
  ${({ theme }) => theme.media.tablet`
    margin-top: 0;
    margin-bottom: 48px;
  `}
  ${({ theme }) => theme.media.desktop`
    margin-top: 24px;
    margin-bottom: 80px;
  `}
`;
